import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 미니게임 리스트
const get_admineventlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventlistcnt: 0,
    eventlist: [],
  };

  const options = {
    method: "GET",
    url: "/event/minigamelist",
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      type: param.type,
      pageno: param.pageno,
      status_cd: param.status_cd,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admineventlist", err);
    result(false, err);
  }
};

// 통합관리이벤트코스리스트
const get_admineventcourselist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventcourselistcnt: 0,
    eventcourselist: [],
  };

  const options = {
    method: "GET",
    url: "/event/eventcourselist",
    params: {},
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admineventcourselist", err);
    result(false, err);
  }
};

// 통합관리이벤트정보보기
const get_admineventview = async (eventno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventinfo: {},
  };

  const options = {
    method: "GET",
    url: "/event/eventview/" + eventno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admineventview", err);
    result(false, err);
  }
};

// 매장 코스보기
const get_admincourseview = async (maincourseno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    courseview: [],
  };

  const options = {
    method: "GET",
    url: "/event/eventcourseview/" + maincourseno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admincourseview", err);
    result(false, err);
  }
};

// 통합관리이벤트등록
const set_admineventwrite = async (form, result) => {
  const options = {
    method: "POST",
    url: "/event/eventwrite",
    data: qs.stringify({
      shopno: form.shopno,
      title: form.title,
      message: form.message,
      successmessage: form.successmessage,
      point: form.point,
      startdate: form.startdate,
      enddate: form.enddate,
      systemrange: form.systemrange,
      type: form.type,
      distance: form.distance,
      entrylimit: form.entrylimit,
      rankprize: form.rankprizelist,
      courseno: form.courseno,
      hole: form.hole,
      isteebox: form.isteebox,
      teeboxman: form.teeboxman,
      teeboxwoman: form.teeboxwoman,
      gender: form.gender,
      status: form.status,
      level_fk: form.level_fk,
      standard_point: form.standard_point,
      oom_point: form.oom_point,
      awardtype: form.awardtype,
      greenspeed_fk: form.greenspeed_fk,
      greengravity_fk: form.greengravity_fk,
    }),
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admineventwrite", err);
    result(false, err);
  }
};

// 통합관리이벤트정수정
const set_admineventedit = async (form, eventno, result) => {
  const options = {
    method: "POST",
    url: "/event/eventwrite/" + eventno,
    data: qs.stringify({
      shopno: form.shopno,
      title: form.title,
      message: form.message,
      successmessage: form.successmessage,
      point: form.point,
      startdate: form.startdate,
      enddate: form.enddate,
      systemrange: form.systemrange,
      type: form.type,
      distance: form.distance,
      entrylimit: form.entrylimit,
      rankprize: form.rankprizelist,
      courseno: form.courseno,
      hole: form.hole,
      teeboxman: form.teeboxman,
      teeboxwoman: form.teeboxwoman,
      course_pk: form.course_pk,
      isteebox: form.isteebox,
      gender: form.gender,
      status: form.status,
      level_fk: form.level_fk,
      standard_point: form.standard_point,
      oom_point: form.oom_point,
      awardtype: form.awardtype,
      greenspeed_fk: form.greenspeed_fk,
      greengravity_fk: form.greengravity_fk,
    }),
  };
  try {
    await axios(options).then((response) => {
      // console.log(response.data);
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        // result(true, response.data)
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admineventedit", err);
    result(false, err);
  }
};

// 통합관리이벤트당첨내역
const get_admineventwinninglist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventwvinninglistcnt: 0,
    eventwvinninglist: [],
  };

  const options = {
    method: "GET",
    url: "/event/eventwinninglist/" + param.eventno,
    params: param,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admineventwinninglist", err);
    result(false, err);
  }
};

// 통합관리이벤트매장리스트
const get_adminshoplist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventshoplistcnt: 0,
    eventshoplist: [],
  };

  const options = {
    method: "GET",
    url: "/event/eventshoplist",
    params: {},
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_adminshoplist", err);
    result(false, err);
  }
};

// 통합관리이벤트삭제
const set_admineventdelete = async (eventno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/eventdelete/" + eventno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admineventdelete", err);
    result(false, err);
  }
};

// 통합관리이벤트당첨내역
const get_eventwinningranklist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventwinningrankcnt: 0,
    eventwinningranklist: [],
    eventinfo: {},
  };

  const options = {
    method: "GET",
    url: "/event/eventwinningranklist/" + param.eventno,
    params: {
      gender: param.gender,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_eventwinningranklist", err);
    result(false, err);
  }
};

const set_reprocess = async (rule_pk, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "GET",
    url: "/event/reprocess/" + rule_pk,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const get_eventplayerlist = async (eventno, params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 5,
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/event/eventplayerlist/" + eventno,
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_tourplayerlist", err);
    result(false, err);
  }
};

const get_playerlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 5,
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/membership/playerlist",
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerlist", err);
    result(false, err);
  }
};

const set_admineventplayersave = async (
  eventno,
  event_member_items,
  result
) => {
  const options = {
    method: "POST",
    url: "/postact/eventplayersave/" + eventno,
    data: qs.stringify(event_member_items),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admineventplayersave", err);
    result(false, err);
  }
};

const excelSave = async (eventno, params, result) => {
  let finalData = {
    code: 0,
    message: "",
  };
  const options = {
    method: "GET",
    url: "/event/eventplayerlist/" + eventno + "/excel",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify({})
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  await axios(options).then((response) => {
    // alert(response.headers["content-disposition"]);
    // console.log(response);
    //  let header = response.headers["Content-Disposition"];

    // let filenameTmp = header.split("=");
    // let filename = filenameTmp[1];
    // let filename = "member_". date("Y-m-d") .".xls";

    result(response.data);
  });
};

export default {
  get_admineventlist,
  get_admineventcourselist,
  get_admineventview,
  get_admincourseview,
  set_admineventwrite,
  set_admineventedit,
  get_admineventwinninglist,
  get_adminshoplist,
  get_eventwinningranklist,
  set_admineventdelete,
  set_reprocess,
  get_eventplayerlist,
  get_playerlist,
  set_admineventplayersave,
  excelSave,
};
